import { useEffect, useState } from "react";
import ReactPlayer from 'react-player'
import { useMediaQuery } from 'react-responsive';
import ImgHelperPhoto from "../img/helper_photo.png";
import { ReactComponent as IconMute } from "../img/icons/mute.svg";
import { ReactComponent as IconUnmute } from "../img/icons/unmute.svg";
import { ReactComponent as IconClose } from "../img/icons/close.svg";

const Helper = ({ step, start }) => {
  const isMobile = useMediaQuery({ maxWidth: 640 });
  const [display, setDisplay] = useState(!isMobile && (step !== 4));
  const [playing] = useState(true);
  const [muted, setMuted] = useState(true);
  const videos = {
    begin: 'presentation.mp4',
    0: 'localisation.mp4',
    1: 'orientation.mp4',
    2: 'surface.mp4',
    3: 'informations.mp4',
    4: 'stockage.mp4'
  };

  useEffect(() => {
    setDisplay(!isMobile && (step !== 4));
  }, [step, isMobile]);

  useEffect(() => {
    if ((start !== null) && (start !== undefined))
      setDisplay(true);
  }, [start]);

  const toggle = () => {
    setMuted(display);
    setDisplay(!display);
  }

  return (
    <div className="helper">
      <div className="bluebtn" onClick={toggle}>Je vous aide !</div>
      <div className="photo" onClick={toggle}><img alt="" src={ImgHelperPhoto} /></div>
      { display && 
      <div id="helper_player">
        <ReactPlayer 
          src={`${process.env.REACT_APP_SIM_VID_URL}/${videos[step]}`} 
          playing={playing} 
          muted={muted}
          width={'100%'}
          height={'auto'}
          onEnded={() => setDisplay(false)}
        /> 
        { muted ? <IconMute className="volume" onClick={() => setMuted(false) }/> : <IconUnmute className="volume" onClick={() => setMuted(true) }/> }
        <IconClose className="close" onClick={() => setDisplay(false) }/>
      </div>
      }
    </div>
  );
};

export default Helper;